import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Colors from '../../../constants/Colors';

interface TicketGroupTagProps {
  groupId: string,
  key: string,
  userGroups,
}

const TicketGroupTag = ({ groupId, key, userGroups }: TicketGroupTagProps) => {
  const groupName = userGroups?.filter((group) => group.UserGroupId === groupId)[0]?.Name;
  return groupName && <View
    style={styles.container}
    key={key}
  >
    <Text style={styles.name}>{groupName}</Text>
  </View>;
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.light.hereworksDarkBlue,
    borderRadius: 6,
    marginRight: 6,
    marginBottom: 6,
    flexShrink: 1,
  },
  name: {
    fontFamily: 'Roboto_400Regular',
    fontSize: 14,
    color: '#fff',
    padding: 4,
    flex: 1,
  },
});

export default TicketGroupTag;
